import { render, staticRenderFns } from "./SmartAssistant.vue?vue&type=template&id=f339d22a&"
import script from "./SmartAssistant.vue?vue&type=script&lang=js&"
export * from "./SmartAssistant.vue?vue&type=script&lang=js&"
import style0 from "./SmartAssistant.vue?vue&type=style&index=0&id=f339d22a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports